import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    effect,
    inject,
    input,
    PLATFORM_ID,
    Renderer2,
    ViewEncapsulation,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import type { ApiTypes } from '@hyundai/ng-common-lib';
import { FootnotesPipe } from '@hyundai/ng-common-lib';

@Component({
    selector: 'ui-m030-c170-faq-module',
    standalone: true,
    templateUrl: './m030-c170-faq-module.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FootnotesPipe],
})
export class M030C170FaqModuleComponent {
    route = inject(ActivatedRoute);
    renderer = inject(Renderer2);
    document = inject(DOCUMENT);
    platformId = inject(PLATFORM_ID);

    faq = input.required<NonNullable<ApiTypes.ModelDetail['faq']>>();

    queryParams = toSignal(this.route.queryParams);
    initialOpenSlug = computed(() => this.queryParams()?.['question'] as string | undefined);

    setStructuredFaqDataEffect = effect((onCleanup) => {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }

        const faq = this.faq();
        const script = this.renderer.createElement('script') satisfies HTMLScriptElement;
        const structuredFaq = {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faq.questions.map((question) => ({
                '@type': 'Question',
                name: question.question,
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: question.answer?.text ?? '',
                },
            })),
        };

        script.type = 'application/ld+json';
        script.text = JSON.stringify(structuredFaq);

        this.renderer.appendChild(this.document.body, script);
        onCleanup(() => this.renderer.removeChild(this.document.body, script));
    });
}
